var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.998 10 2.1-.259a.667.667 0 0 0 .391-.19l5.09-5.086a1.444 1.444 0 0 0 0-2.041v0a1.444 1.444 0 0 0-2.042 0L6.495 7.466a.667.667 0 0 0-.189.377z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.665 2.664a5.669 5.669 0 1 0 5.67 5.67M12.354 5.686l-2.041-2.042"
  })));
};
export { SvgEdit as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNzE1Yzg1MDlkYjRiZTliNGZmNjEyYzhlMjA0NmJkM2Iuc3ZnIjs=";